import * as React from "react";
import SearchHeader from "../layouts/SearchHeader";
import RateLibraryGridList from "../layouts/RateLibraryGridList";
import { Grid } from "@material-ui/core";
import { RateLibraryService } from "../../RateLibraryService";
import { RateLibraryStore } from "../../RateLibraryStore";
import SubscribeNowCard from "modules/development/components/layouts/SubscribeNowCard";
import i18n from "i18n";

class RateLibrary extends React.Component {
  state = { developments: [], ready: false, cancelEdit: false };

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    await this.getRateLibraries();
    document.title = `Rubk - ${i18n.menu.rateLibrary}`;
  }

  componentWillUnmount() {
    document.title = "Rubk";
    RateLibraryStore.resetStore();
  }
  async getRateLibraries() {
    await RateLibraryService.fetchAvailableRateLibraries();
  }

  public render() {
    return (
      <div>
        <SubscribeNowCard />
        <Grid container>
          <Grid item xs={12}>
            <SearchHeader />
          </Grid>
          <Grid item xs={12}>
            <RateLibraryGridList />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default RateLibrary;



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/components/pages/RateLibrary.tsx